import React, { useState } from "react";
import { GetOneTransfer, UPDATETRANSFER } from "helpers/api";
import moment from "moment";
import Modal from "components/Modal";
import { useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "components/Button";
import classNames from "classnames";

const HomeClient = () => {
  const [valueCode, setValueCode] = useState("");
  const [data, setData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const formik = useFormik({
    initialValues: {
      cin: "",
      file: null,
      file1: null,
    },
    validationSchema: yup.object({
      cin: yup.string().trim().required("Ce champ est requis"),
      file: yup.mixed().required("Ce champ est requis"),
      file1: yup.mixed().required("Ce champ est requis"),
    }),

    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("file1", values?.file);
      const formData1 = new FormData();
      formData1.append("file2", values?.file1);

      UPDATETRANSFER({
        transferId: data[0]?._id,
        identityCard: values?.cin,
        file1: values?.file,
        file2: values?.file1,
      })
        .then(() => {
          toast("Document ajouté avec succès", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "success",
          });
          setData(null);
          setValueCode("");
        })
        .catch((err) => {
          toast("Erreur", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            type: "error",
          });
        });
      setOpenModal(false);
      formik.resetForm();
    },
  });
  const searchCode = () => {
    GetOneTransfer({ code: valueCode })
      .then((response) => {
        setData(response?.transfer);
      })
      .catch((err) => {
        console.log("error");
      });
  };
  const handleChangeMontant = (e) => {
    const inputValue = e.target.value;
    if (/^\d*\.?\d*$/.test(inputValue)) {
      formik.setFieldValue("cin", inputValue);
    }
  };
  return (
    <div className="flex flex-col pl-16 lg:pl-0 w-full items-center ">
      <div className="flex flex-col gap-4 items-center">
        <span className="text-[30px] my-10 text-[#5d55e8] font-bold">
          Entrez le code du transfert
        </span>
        <input
          value={valueCode}
          onChange={(e) => setValueCode(e.target.value)}
          name="code"
          type="text"
          className="mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4  w-[300px] h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light"
        />
        <div
          className={classNames(
            "2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10",
            `text-[#DC143C]`
          )}
        >
          {data && data?.length === 0 && "Code invalid"}{" "}
        </div>
        <Button type="submit" variant="primary" onClick={searchCode}>
          <div className="flex items-center justify-center gap-10  w-full  ">
            <div className="text-sm font-bold text-white text-[18px]">
              Recherchez
            </div>
          </div>
        </Button>
      </div>

      <div className="mt-8 flex flex-col gap-8">
        <div className="text-[20px] py-[50px] text-[#5d55e8] font-bold">
          Détail du transfert
        </div>
        <div className="flex gap-8 items-center">
          <div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Code du transfert :
              </span>
              <span className=" text-[18px] text-[#DB7093] font-semibold">
                {data && data[0]?.code}{" "}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Date du transfert:
              </span>
              <span className=" text-[18px] ">
                {data &&
                  data[0] &&
                  moment(data[0]?.date)?.format("DD/MM/YYYY hh:mm")}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Expéditeur :</span>
              <span className=" text-[18px] ">
                {data && data[0]?.em_firstname} {data && data[0]?.em_lastname}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">Bénéficiaire :</span>
              <span className=" text-[18px] text-[#DB7093] font-semibold">
                {data && data[0]?.dest_firstname}{" "}
                {data && data[0]?.dest_lastname}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Téléphone du bénéficiaire :
              </span>
              <span className=" text-[18px]">{data && data[0]?.dest_tel} </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px] ">
                Montant du transfert :
              </span>
              <span className=" text-[18px] text-[#DB7093] font-semibold">
                {data && data[0]?.amount} {data && data[0]?.currency}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <span className="font-semibold text-[20px]">
                Statut du transfert :
              </span>
              <span className=" text-[18px]">{data && data[0]?.status}</span>
            </div>
          </div>
          <form className="border-2 mt-4 rounded flex flex-col items-center ">
            <div className="flex flex-col gap-2 items-center  px-4 py-4 h-[120px]">
              <span className="font-semibold text-[16px]">
                Ajoutez numéro de CIN du bénéficiaire :
              </span>
              <input
                disabled={data && data[0]?._id ? "" : "disabled"}
                label="Ajouter numéro de CIN :"
                value={formik.values.cin}
                onChange={(e) => handleChangeMontant(e)}
                onBlur={formik.handleBlur}
                name="cin"
                type="text"
                placeholder="Ajouter numéro de CIN :"
                maxLength={8}
                className=" mt-[8px] border-[1px] border-[#292524] resize-none px-4  py-4 w-2/3 h-[50px] rounded  bg-white text-sm text-[#1E2E58] placeholder-[#8E96AB] border-lena2021-gray-light "
              />
              {formik.touched.cin && (
                <span className="2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10 text-[#DC143C] ">
                  {formik.errors.cin}
                </span>
              )}
            </div>

            <div className="flex flex-col gap-2 items-center  px-4 py-4 h-[120px]">
              <span className="font-semibold text-[16px]">
                Ajoutez la recto CIN (PDF, PNG, JPG or JPEG) :
              </span>

              <input
                disabled={data && data[0]?._id ? "" : "disabled"}
                onChange={(e) =>
                  formik.setFieldValue("file", e.target.files[0])
                }
                onBlur={formik.handleBlur}
                id="file"
                name="file"
                type="file"
                error={formik.touched.file ? formik.errors.file : ""}
                maxLength={8}
              />
              {formik.touched.file && data && data[0]?._id && (
                <span className="2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10 text-[#DC143C] ">
                  {formik.errors.file}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-2 items-center  px-4 py-4 h-[120px]">
              <span className="font-semibold text-[16px]">
                Ajoutez la verso CIN (PDF, PNG, JPG or JPEG):
              </span>

              <input
                disabled={data && data[0]?._id ? "" : "disabled"}
                onChange={(e) =>
                  formik.setFieldValue("file1", e.target.files[0])
                }
                onBlur={formik.handleBlur}
                id="file1"
                name="file1"
                type="file"
                error={formik.touched.file1 ? formik.errors.file1 : ""}
                maxLength={8}
              />
              {formik.touched.file1 && data && data[0]?._id && (
                <span className="2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10 text-[#DC143C] ">
                  {formik.errors.file1}
                </span>
              )}
            </div>
            <div className="flex  py-2 gap-2 items-center ">
              <div
                className={classNames(
                  " h-[50px] px-2  w-[200px] mx-auto rounded flex items-center justify-center",
                  formik?.values?.cin &&
                    formik?.values?.file &&
                    formik?.values?.file1
                    ? "bg-[#5d55e8] text-white"
                    : "bg-grey-300 text-black"
                )}
                disabled={
                  formik?.values?.cin &&
                  formik?.values?.file &&
                  formik?.values?.file1
                    ? false
                    : true
                }
                onClick={() => setOpenModal(true)}
              >
                Finalisez
              </div>{" "}
            </div>
          </form>
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        className=" h-[300px] w-[480px] px-12 "
       
      >
        <span className="text-[30px] mt-8 ">
          Merci de confirmer que le bénéficiaire a retiré le montant du
          transfert
        </span>
        <div className="flex gap-6 w-2/3 mx-auto mt-8">
          <Button
            onClick={formik.handleSubmit}
            variant="primary"
            className="w-full mb-30 2xl:mb-2 lg:mb-5 h-16 py-1.5 rounded-5 hover:bg-green hover:text-white	2xl:h-14 3xl:text-xl sm:text-base 2xl:text-lg  "
          >
            Confirmez
          </Button>{" "}
          <Button
            onClick={() => setOpenModal(false)}
            variant="red"
            className="w-full mb-30 2xl:mb-2 lg:mb-5 h-16 py-1.5 rounded-5  text-white	2xl:h-14 3xl:text-xl sm:text-base 2xl:text-lg  "
          >
            Annulez
          </Button>
        </div>
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default HomeClient;
